export default __webpack_public_path__ + "static/media/NotOnlyPolygon.311276ed.svg";